import Extras from '@pages/Extras'
import PodForm from '@pages/Extras/PodForm'
const { withSuspense } = require('./routeUtils')
const { Navigate } = require('react-router')
const { default: paths } = require('@routes/paths')

const ExtraRoutes = {
	path: '/extra',
	element: withSuspense(<Extras />),
	children: [
		{ index: true, element: <Navigate to='pod-form' /> },
		{
			path: paths.pod_form,
			element: withSuspense(<PodForm />),
		},
		{ path: '*', element: <Navigate to='pod-form' /> },
	],
}

export default ExtraRoutes
